import getBrowser from "@core/utils/helpers/getBrowser";
import { Loader } from '@googlemaps/js-api-loader'
import {FC, useEffect, useId} from 'react'

type Props = {
    data:
    | string
    | {
        FormattedAddress?: string
        Lat: string
        Lng: string
        PlaceID?: string
    }[]
}

export const Map: FC<Props> = ({ data }) => {
    const mapId = useId()
    const loader = new Loader({
        apiKey: 'AIzaSyDshC1CWnnSf92AlC-5w0-o6DLAfQQZs70',
        // version: '3.53',
        version: 'quarterly',
        libraries: ['places'],
    })

    console.log(getBrowser())


    const addNewMarker = async (
        obj: { Lat: string; Lng: string },
        map: google.maps.Map | undefined,
        bounds: google.maps.LatLngBounds
    ) => {
        if (!map) {
            console.error('Map is not initialized.')
            return
        }
        const {AdvancedMarkerElement} = await loader.importLibrary("marker")
        const marker = new AdvancedMarkerElement({
            map: map,
            position: { lat: +obj.Lat, lng: +obj.Lng },
        })
        // let marker = new window.google.maps.Marker()

        let latlng = {
            lat: +obj.Lat,
            lng: +obj.Lng,
        }

        // marker.setPosition(latlng)
        // marker.setMap(map)
        bounds.extend(latlng)
    }

    const handleSingleLocation = (
        address: string | { Lat: string; Lng: string; FormattedAddress?: string },
        map: google.maps.Map | undefined,
        geocoder: google.maps.Geocoder,
        bounds: google.maps.LatLngBounds
    ) => {
        if (!map) {
            console.error('Map is not initialized.')
            return
        }

        if (typeof address === 'string') {
            geocoder.geocode({ address }).then((result: any) => {
                const { results } = result
                if (results.length > 0) {
                    let latlng = {
                        Lat: results[0].geometry.location.lat().toString(),
                        Lng: results[0].geometry.location.lng().toString(),
                    }
                    addNewMarker(latlng, map, bounds)
                    map.setCenter({ lat: +latlng.Lat, lng: +latlng.Lng })
                    map.setZoom(14) // Fixed zoom level for a single location
                }
            }).catch((error: any) => {
                console.error('Geocode was not successful for the following reason: ' + error);
            });
        } else {
            let latlng = {
                lat: +address.Lat,
                lng: +address.Lng,
            }
            addNewMarker(address, map, bounds)
            map.setCenter(latlng)
            map.setZoom(14) // Fixed zoom level for a single location
        }
    }

    const handleMultipleLocations = (
        locations: { Lat: string; Lng: string; FormattedAddress?: string }[],
        map: google.maps.Map | undefined,
        geocoder: google.maps.Geocoder,
        bounds: google.maps.LatLngBounds
    ) => {
        if (!map) {
            console.error('Map is not initialized.')
            return
        }
        const uniqueCoordinates = new Set<string>()

        const promises = locations.map((obj) => {
            if (!obj.Lat || !obj.Lng) {
                console.warn('Invalid coordinates:', obj)
                return Promise.resolve()
            }

            const latLngString = `${obj.Lat},${obj.Lng}`

            if (uniqueCoordinates.has(latLngString)) {
                return Promise.resolve()
            }

            uniqueCoordinates.add(latLngString)

            if (obj.FormattedAddress) {
                return geocoder.geocode({ address: obj.FormattedAddress }).then((result: any) => {
                    const { results } = result
                    if (results.length > 0) {
                        let latlng = {
                            Lat: results[0].geometry.location.lat().toString(),
                            Lng: results[0].geometry.location.lng().toString(),
                        }
                        addNewMarker(latlng, map, bounds).catch((error: any) => {
                            console.error('Geocode was not successful for the following reason: ' + error);
                        })
                    }
                })
            } else {
                addNewMarker(
                    {
                        Lat: obj.Lat,
                        Lng: obj.Lng,
                    },
                    map,
                    bounds
                ).catch((error: any) => {
                    console.error('Geocode was not successful for the following reason: ' + error);
                })
            }
        })

        Promise.all(promises).then(() => {
            if (uniqueCoordinates.size === 1) {
                const latlngString = Array.from(uniqueCoordinates)[0].split(',')
                const latlng = {
                    Lat: latlngString[0],
                    Lng: latlngString[1],
                }

                map.setCenter({ lat: +latlng.Lat, lng: +latlng.Lng })
                map.setZoom(14)
            } else {
                map.fitBounds(bounds)
            }
        })
    }


    useEffect(() => {
        const initMap = async () => {
            const [maps, geocoding, core] = await Promise.all([
                loader.importLibrary('maps'),
                loader.importLibrary('geocoding'),
                loader.importLibrary('core'),
            ])
            const map = new maps.Map(document.getElementById(mapId) as HTMLElement, {
                center: {lat: 50.4501, lng: 30.5234},
                zoom: 8,
                disableDefaultUI: true,
                mapId
            })
            const geocoder = new geocoding.Geocoder()
            const bounds = new core.LatLngBounds()
            if (typeof data === 'string' || (Array.isArray(data) && data.length === 1)) {
                handleSingleLocation(
                  typeof data === 'string' ? data : data[0],
                  map,
                  geocoder,
                  bounds
                )
            } else {
                handleMultipleLocations(data as any[], map, geocoder, bounds)
            }
        }

        initMap().catch((error: any) => {
            console.error('Map initialization failed: ' + error);
        });
    }, [data])

    return <div id={mapId} style={{ height: '90%', width: '100%' }} />
}
